import { __rest } from '../../../_virtual/_tslib.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import Input from '../../Input/Input.js';
import Select from '../../Select/Select.js';
import TextArea from '../../TextArea/TextArea.js';

const JsonForm = ({ formData }) => {
    return (jsx(Fragment, { children: formData.map((_schema, ix) => {
            const schema = Object.assign({ isVisible: true }, _schema);
            if (!(schema === null || schema === void 0 ? void 0 : schema.isVisible)) {
                return null;
            }
            if (schema.formInputType === "dropdown") {
                const restProps = __rest(schema, ["formInputType"]);
                return jsx(Select, Object.assign({}, restProps), ix);
            }
            else if (schema.formInputType === "input") {
                const restProps = __rest(schema, ["formInputType"]);
                return jsx(Input, Object.assign({}, restProps), ix);
            }
            else if (schema.formInputType === "text-area") {
                const restProps = __rest(schema, ["formInputType"]);
                return jsx(TextArea, Object.assign({}, restProps), ix);
            }
        }) }));
};

export { JsonForm as default };
//# sourceMappingURL=JsonForm.js.map
